<template>
  <v-card class="mx-auto" elevation="0">
    <v-card-title class="card-header fixed-card-title2">
      {{ $t('add-organization-mapping') }}
      <v-spacer></v-spacer>
      <v-icon @click="closeDrawer" class="white-icon mr-3">mdi-close</v-icon>
    </v-card-title>
    <v-card-text>
      <v-row class="mt-2">
        <v-col class="d-flex pa-1" cols="12" sm="12">
          <v-text-field outlined dense hide-details="auto" v-model="ecpCompanyGuid"
            :label="`${$t('organization')} GUID`" required>
          </v-text-field>
        </v-col>
        <v-col class="d-flex pa-1" cols="12" sm="12">
          <v-text-field outlined dense hide-details="auto" v-model="ecpCompanyName"
            :label="`${$t('organization')} ${$t('name')} `" required>
          </v-text-field>
        </v-col>
        <v-col class="d-flex pa-1" cols="12" sm="12">

          <v-select class="py-1" hide-details dense v-model="selectedMedicalInstitution" :items="allMedicalInstitutions"
            item-value="id" item-text="institutionName" :label="$t('medical-institutions')" outlined>
          </v-select>
        </v-col>
      </v-row>

    </v-card-text>
    <v-card-actions class="fixed-card-actions">
      <v-row dense class="mx-0 px-0 mr-2">
        <v-col cols="6">
          <v-btn elevation="0" @click="closeDrawer" class="cancel-button-style capitalize-text">
            {{ $t('cancel') }}
          </v-btn>
        </v-col>
        <v-col cols="6">
          <v-btn :disabled="isSaveButtonDisabled()" @click="saveOrganizationMapping" class="save-button-style">
            {{ $t('save') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import MappingRepository from '../../data/repositories/v1/MappingRepository';

export default {
  name: 'OrganizationMappingAdd',
  data: () => ({
    componentKey: 0,
    menu: false,
    defaultTimeZone: 'America/Chicago',
    selectedMedicalInstitution: null,
    ecpCompanyGuid: '',
    ecpCompanyName: '',
  }),
  computed: {
    ...mapState({
      allMedicalInstitutions: (state) => state.medicalInstitutions.medicalInstitutions,
      hospitals: (state) => state.hospitals.hospitals,
    }),
    ...mapGetters({
      getTimeZone: 'verifiers/getTimeZone',
    }),
  },
  mounted () {
    this.getMedicalInstitutions();
  },
  methods: {
    ...mapActions({
      getMedicalInstitutions: 'medicalInstitutions/getMedicalInstitutions',
    }),
    isSaveButtonDisabled () {
      return (
        !this.selectedMedicalInstitution ||
        this.ecpCompanyGuid.length === 0 ||
        this.ecpCompanyName.length === 0
      );
    },
    resetComponent () {
      this.selectedMedicalInstitution = null;
      this.ecpCompanyGuid = '';
      this.ecpCompanyName = '';
    },
    async saveOrganizationMapping () {
      const body = {
       medicalInstitutionId: this.selectedMedicalInstitution,
      ecpCompanyGuid: this.ecpCompanyGuid,
      ecpCompanyName: this.ecpCompanyName,
      };
      MappingRepository.addEcpMapForCompany(body)
      .then(res => {
				this.closeDrawer();
      });
    },
  closeDrawer () {
    this.resetComponent();
    this.$store.commit('SET_DETAILS_DRAWER', false);
  },
  },
};
</script>
<style scoped>
.map-container {
  margin-top: 20px;
  /* Adjust this margin as needed */
}
</style>
